/**
 * Pull the playlist filename out of a player's PLAYLIST log line.
 *
 * A player logs the list it loaded as one long line, e.g.
 *
 *   PLAYLIST - StartingList (offline)  --loop
 *   20260721000948202607241 00001--Main____.7.24Fri.txt mono gvplayer 50.1.46
 *
 * The filename in there is the same kind of reported name a check-in carries,
 * so it resolves through the same server-side rules and opens the same record.
 * Two things are always true of these lines and are what this matches on: they
 * start with PLAYLIST, and the filename ends in .txt.
 *
 * Returns null for any other log line, so nothing else in the log becomes a
 * link by accident.
 */
export function playlistFileNameInLogMessage(message: string | null): string | null {
    if (message === null) {
        return null;
    }
    if (!/^\s*PLAYLIST\b/i.test(message)) {
        return null;
    }
    // The filename is a run of non-whitespace ending in .txt.
    const match = message.match(/(\S+\.txt)/i);
    return match ? match[1] : null;
}
